import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoEllipseVertical = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 34 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>EllipseVertical</title>
    <circle cx={17.001} cy={17.112} r={1.714} transform="rotate(90 17.001 17.112)" fill="currentColor" />
    <circle cx={17.001} cy={10.255} r={1.714} transform="rotate(90 17 10.255)" fill="currentColor" />
    <circle cx={17.001} cy={23.97} r={1.714} transform="rotate(90 17.001 23.97)" fill="currentColor" />
  </svg>
);
export default SvgIcoEllipseVertical;
